function getCharacterWidths(font, characters) {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    context.font = font

    // Measure the width of two underscores to establish baseline
    const underscoreWidth = context.measureText('__').width

    const characterWidths = {}

    for (const char of characters) {
        const widthWithChar = context.measureText(`_${char}_`).width
        const charWidth = widthWithChar - underscoreWidth
        characterWidths[char] = charWidth
    }

    return characterWidths
}

const font = '11px Calibri' // Set your desired font
const characters =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()[]{};:\'"<>?,./\\|`~_-+= àâçéèêëîïôûùüÿœæÀÂÇÉÈÊËÎÏÔÛÙÜŸŒÆ'
const characterWidths = getCharacterWidths(font, characters)

// Updated getObjectLength function
const getObjectLength = (object) => {
    const calculateStringWidth = (string) => {
        return string
            .split('')
            .reduce((totalWidth, char) => totalWidth + (characterWidths[char] || characterWidths['a']), 0)
    }

    if (typeof object === 'string') {
        return Math.max(...object.split('\n').map((string) => calculateStringWidth(string)))
    }
    if (typeof object === 'number') {
        return calculateStringWidth(object.toString())
    }
    if (typeof object === 'boolean') {
        return calculateStringWidth(object ? 'true' : 'false')
    }
    if (object instanceof Date) {
        return calculateStringWidth(object.toString())
    }
    return 0
}

export const getColumnWidths = (data) => {
    // Find the maximum column count in any row
    const columnCount = Math.max(...data.map((row) => row.length))

    // Initialize an array to hold column widths
    const columnWidths = new Array(columnCount).fill(0)

    // Loop through each row and column to determine the maximum width
    data.forEach((row) => {
        row.forEach((cell, columnIndex) => {
            const cellLength = getObjectLength(cell)
            columnWidths[columnIndex] = Math.max(columnWidths[columnIndex], cellLength)
        })
    })

    // Add extraLength and return the result
    return columnWidths.map((width) => ({ wpx: width * 1.1 + 15 }))
}

export const getRowHeights = (data) => {
    // Initialize an array to hold row heights
    const rowHeights = data.map((row) => {
        let maxLines = 1 // Minimum one line per row
        let containsMultiline = false

        row.forEach((cell) => {
            const cellValue = cell?.v || cell || ''
            if (typeof cellValue === 'string' || typeof cellValue === 'number') {
                const lineCount = String(cellValue).split('\n').length
                if (lineCount > 1) {
                    containsMultiline = true // Mark row as containing multiline content
                    maxLines = Math.max(maxLines, lineCount)
                }
            }
        })

        // Only set hpx if the row contains multiline content
        return containsMultiline ? { hpx: maxLines * 20 + 5 } : undefined
    })

    return rowHeights
}

export const getCellStyle = (bold = false, isBlackAndWhite = false, isGrey = false) => ({
    font: { bold, color: { ...(isBlackAndWhite ? { rgb: 'ffffff' } : {}) } },
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    ...(isBlackAndWhite
        ? {
              fill: {
                  patternType: 'solid',
                  fgColor: { rgb: '222222' },
              },
          }
        : isGrey
        ? {
              fill: {
                  patternType: 'solid',
                  fgColor: { rgb: 'efefef' },
              },
          }
        : {}),
    border: isGrey
        ? {
              top: { style: 'thin', color: { rgb: 'e1e1e1' } },
              bottom: { style: 'thin', color: { rgb: 'e1e1e1' } },
              left: { style: 'thin', color: { rgb: 'e1e1e1' } },
              right: { style: 'thin', color: { rgb: 'e1e1e1' } },
          }
        : {},
})

export const getValidName = (name) => name.replace(/[\\\/\?\*\[\]]/g, '_')

const hslToHex = (h, s, l) => {
    s /= 100
    l /= 100

    const k = (n) => (n + h / 30) % 12
    const a = s * Math.min(l, 1 - l)
    const f = (n) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))

    return `#${[f(0), f(8), f(4)]
        .map((x) =>
            Math.round(x * 255)
                .toString(16)
                .padStart(2, '0'),
        )
        .join('')}`
}

export const generateColors = (count) => {
    const colors = []
    const goldenRatio = 0.618033988749895 // Golden ratio for better spacing
    let hue = Math.random() * 360 // Start with a random hue for variation
    for (let i = 0; i < count; i++) {
        hue = (hue + goldenRatio * 360) % 360 // Use golden ratio for hue increment
        const saturation = 50 + (i % 2) * 20 // Alternate saturation for contrast
        const color = hslToHex(hue, saturation, 60) // Convert HSL to HEX
        colors.push(color)
    }
    return colors
}
